export default "__VITE_ASSET__BpEjt4rq__"